import _ from '../../utils'
import PAGE_TRANSITION_CONFIG from '../config'
import PAGE_TRANSITION_LOADER from '../transitioning'
import { gsap } from 'gsap'

let tl = gsap.timeline()


const FADE_TRANSITION = {
    name: 'fade-transition',
    leave( data ) {
        PAGE_TRANSITION_LOADER._loading()
        tl.to( PAGE_TRANSITION_CONFIG.transition, {
            opacity: 1,
            duration: .5
        })
    },
    enter( data ) {
        tl.to( PAGE_TRANSITION_CONFIG.transition, {
            opacity: 0,
            duration: .5,
            onComplete: () => {
                PAGE_TRANSITION_LOADER._loaded()
            }
        })
    }
}

export default FADE_TRANSITION